import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Arbitrary JSON Type */
  JsonObject: any;
};

export type ChartOption = {
  __typename?: 'ChartOption';
  cohort?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['JsonObject']>;
  entityType: Scalars['String'];
  id: Scalars['ID'];
  pastResults?: Maybe<Scalars['Boolean']>;
  subgroup?: Maybe<Scalars['String']>;
};

export enum ChartOptionElement {
  /** A report element such as a chart */
  Element = 'ELEMENT',
  /** A whole report */
  Report = 'REPORT'
}

export type ChartOptionInput = {
  cohort?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['JsonObject']>;
  pastResults?: InputMaybe<Scalars['Boolean']>;
  subgroup?: InputMaybe<Scalars['String']>;
};

export type ChartUri = {
  __typename?: 'ChartUri';
  base64: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type ChartUriInput = {
  base64: Scalars['String'];
  title: Scalars['String'];
};

/** Autogenerated input type of CreateChartUri */
export type CreateChartUriInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: ChartUriInput;
};

/** Autogenerated return type of CreateChartUri. */
export type CreateChartUriPayload = {
  __typename?: 'CreateChartUriPayload';
  chartUri?: Maybe<ChartUri>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Autogenerated input type of CreatePdfReport */
export type CreatePdfReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: PdfReportInput;
};

/** Autogenerated return type of CreatePdfReport. */
export type CreatePdfReportPayload = {
  __typename?: 'CreatePdfReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  pdfReport?: Maybe<PdfReport>;
  success: Scalars['Boolean'];
};

export type DownloadMaterial = {
  __typename?: 'DownloadMaterial';
  id: Scalars['ID'];
  path: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createChartUri?: Maybe<CreateChartUriPayload>;
  createPdfReport?: Maybe<CreatePdfReportPayload>;
  removeChartOption?: Maybe<RemoveChartOptionPayload>;
  removeReportFavorite?: Maybe<RemoveReportFavoritePayload>;
  resetChartOptions?: Maybe<ResetChartOptionsPayload>;
  setChartOption?: Maybe<SetChartOptionPayload>;
  setReportFavorite?: Maybe<SetReportFavoritePayload>;
  shareReports?: Maybe<ShareReportsPayload>;
};


export type MutationCreateChartUriArgs = {
  input: CreateChartUriInput;
};


export type MutationCreatePdfReportArgs = {
  input: CreatePdfReportInput;
};


export type MutationRemoveChartOptionArgs = {
  input: RemoveChartOptionInput;
};


export type MutationRemoveReportFavoriteArgs = {
  input: RemoveReportFavoriteInput;
};


export type MutationResetChartOptionsArgs = {
  input: ResetChartOptionsInput;
};


export type MutationSetChartOptionArgs = {
  input: SetChartOptionInput;
};


export type MutationSetReportFavoriteArgs = {
  input: SetReportFavoriteInput;
};


export type MutationShareReportsArgs = {
  input: ShareReportsInput;
};

export type PdfReport = {
  __typename?: 'PdfReport';
  id: Scalars['ID'];
  percentComplete: Scalars['Int'];
  randomKey: Scalars['String'];
  status: Scalars['String'];
};

export type PdfReportInput = {
  onlyFavorites: Scalars['Boolean'];
  reportId: Scalars['String'];
};

export type PdfReportSection = {
  __typename?: 'PdfReportSection';
  childReportSections: Array<ReportSection>;
  reportSection: ReportSection;
};

export type Query = {
  __typename?: 'Query';
  /** Return a chart option for a given id and type */
  chartOption?: Maybe<ChartOption>;
  /** Get list of reports a client can manage */
  managedReports: Array<ReportManager>;
  /** Get list of reports for a year a client can manage */
  managedReportsByYear: Array<ReportManager>;
  /** List reports for the current client paged */
  pagedReports: Array<ReportListItem>;
  /** Return a PdfReport for a given random key */
  pdfReport?: Maybe<PdfReport>;
  /** Return a ReportSection with details for generating a PDF */
  pdfReportSection: PdfReportSection;
  /** Return all elements for a report section */
  printReportElements: Array<ReportElement>;
  /** Return all data for a single report */
  report?: Maybe<Report>;
  /** Return all elements for a report section */
  reportElements: Array<ReportElement>;
  /** Return a report favorite for a given id and type */
  reportFavorite?: Maybe<ReportFavorite>;
  /** Return all favorite elements for a report section */
  reportFavoriteElements: Array<ReportElement>;
  /** List of tags availabe for a display year */
  reportTaggingsByYear: Array<ReportTagging>;
  /** Return all data for a single report scoped to favorites */
  reportWithFavorites?: Maybe<ReportWithFavorites>;
  /** Get list of display years available to a user */
  reportYears: Array<Scalars['Int']>;
  /** List reports for the current client */
  reports: Array<ReportListItem>;
  /** List reports for the current client and display year */
  reportsByYear: Array<ReportListItem>;
  /** Get total pages for paginated reports */
  reportsPageCount: ReportsCount;
  /** Get list of tags for client reports */
  reportsTaggings: Array<ReportTagging>;
  /** Search reports for the current client */
  searchReports: Array<SearchHit>;
  /** Search sections for the current report */
  searchSections: Array<SearchHit>;
};


export type QueryChartOptionArgs = {
  id: Scalars['ID'];
  type: ChartOptionElement;
};


export type QueryManagedReportsByYearArgs = {
  year: Scalars['Int'];
};


export type QueryPagedReportsArgs = {
  page: Scalars['Int'];
  perPage: Scalars['Int'];
};


export type QueryPdfReportArgs = {
  randomKey: Scalars['String'];
};


export type QueryPdfReportSectionArgs = {
  favorites: Scalars['Boolean'];
  sectionId: Scalars['ID'];
};


export type QueryPrintReportElementsArgs = {
  reportId: Scalars['ID'];
  sectionId: Scalars['ID'];
};


export type QueryReportArgs = {
  id: Scalars['ID'];
};


export type QueryReportElementsArgs = {
  reportId: Scalars['ID'];
  sectionId: Scalars['ID'];
};


export type QueryReportFavoriteArgs = {
  id: Scalars['ID'];
  type: ReportFavoriteElement;
};


export type QueryReportFavoriteElementsArgs = {
  reportId: Scalars['ID'];
  sectionId: Scalars['ID'];
};


export type QueryReportTaggingsByYearArgs = {
  year: Scalars['Int'];
};


export type QueryReportWithFavoritesArgs = {
  id: Scalars['ID'];
};


export type QueryReportsByYearArgs = {
  year: Scalars['Int'];
};


export type QueryReportsPageCountArgs = {
  perPage: Scalars['Int'];
};


export type QuerySearchReportsArgs = {
  query: Scalars['String'];
};


export type QuerySearchSectionsArgs = {
  query: Scalars['String'];
  reportId: Scalars['String'];
};

/** Autogenerated input type of RemoveChartOption */
export type RemoveChartOptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  type: ChartOptionElement;
};

/** Autogenerated return type of RemoveChartOption. */
export type RemoveChartOptionPayload = {
  __typename?: 'RemoveChartOptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Autogenerated input type of RemoveReportFavorite */
export type RemoveReportFavoriteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  type: ReportFavoriteElement;
};

/** Autogenerated return type of RemoveReportFavorite. */
export type RemoveReportFavoritePayload = {
  __typename?: 'RemoveReportFavoritePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Report = {
  __typename?: 'Report';
  canManage: Scalars['Boolean'];
  canPresent: Scalars['Boolean'];
  chartOption?: Maybe<ChartOption>;
  cohorts: Array<Scalars['String']>;
  data?: Maybe<Scalars['JsonObject']>;
  downloadMaterials: Array<DownloadMaterial>;
  id: Scalars['ID'];
  publishedYear?: Maybe<Scalars['String']>;
  reportType?: Maybe<Scalars['String']>;
  schoolName?: Maybe<Scalars['String']>;
  scrapedDownloadMaterials: Array<ScrapedDownloadMaterial>;
  sections: Array<ReportSection>;
  subgroups: Array<Scalars['String']>;
  surveyType?: Maybe<Scalars['String']>;
  tags: ReportTags;
  title?: Maybe<Scalars['String']>;
};

export type ReportElement = {
  __typename?: 'ReportElement';
  chartOption?: Maybe<ChartOption>;
  content?: Maybe<Scalars['String']>;
  contentType: Scalars['String'];
  hasSectionFavorite: Scalars['Boolean'];
  id: Scalars['ID'];
  reportFavorite?: Maybe<ReportFavorite>;
};

export type ReportFavorite = {
  __typename?: 'ReportFavorite';
  id: Scalars['ID'];
};

export enum ReportFavoriteElement {
  /** A report element such as a chart */
  Element = 'ELEMENT',
  /** A whole report section */
  Section = 'SECTION'
}

export type ReportListItem = {
  __typename?: 'ReportListItem';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type ReportManager = {
  __typename?: 'ReportManager';
  reportId: Scalars['ID'];
};

export type ReportSection = {
  __typename?: 'ReportSection';
  hasAllElementFavorites: Scalars['Boolean'];
  hasChildFavorites: Scalars['Boolean'];
  hasElementFavorites: Scalars['Boolean'];
  id: Scalars['ID'];
  parentReportSectionId?: Maybe<Scalars['ID']>;
  reportFavorite?: Maybe<ReportFavorite>;
  title?: Maybe<Scalars['String']>;
};

export type ReportTagging = {
  __typename?: 'ReportTagging';
  reportId: Scalars['ID'];
  tags: ReportTags;
};

export type ReportTags = {
  __typename?: 'ReportTags';
  commentsTags: Array<Scalars['String']>;
  districtTags: Array<Scalars['String']>;
  levelTags: Array<Scalars['String']>;
  reportTypeTags: Array<Scalars['String']>;
  schoolTags: Array<Scalars['String']>;
  surveyType: Array<Scalars['String']>;
  yearTags: Array<Scalars['String']>;
};

export type ReportWithFavorites = {
  __typename?: 'ReportWithFavorites';
  canPresent: Scalars['Boolean'];
  chartOption?: Maybe<ChartOption>;
  cohorts: Array<Scalars['String']>;
  data?: Maybe<Scalars['JsonObject']>;
  downloadMaterials: Array<DownloadMaterial>;
  id: Scalars['ID'];
  publishedYear?: Maybe<Scalars['String']>;
  reportType?: Maybe<Scalars['String']>;
  schoolName?: Maybe<Scalars['String']>;
  scrapedDownloadMaterials: Array<ScrapedDownloadMaterial>;
  sections: Array<ReportSection>;
  subgroups: Array<Scalars['String']>;
  surveyType?: Maybe<Scalars['String']>;
  tags: ReportTags;
  title?: Maybe<Scalars['String']>;
};

export type ReportsCount = {
  __typename?: 'ReportsCount';
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

/** Autogenerated input type of ResetChartOptions */
export type ResetChartOptionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ResetChartOptions. */
export type ResetChartOptionsPayload = {
  __typename?: 'ResetChartOptionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ScrapedDownloadMaterial = {
  __typename?: 'ScrapedDownloadMaterial';
  cleanedLink?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
};

export type SearchHit = {
  __typename?: 'SearchHit';
  match: Scalars['String'];
  reportId: Scalars['ID'];
  sectionId?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
};

/** Autogenerated input type of SetChartOption */
export type SetChartOptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  input: ChartOptionInput;
  type: ChartOptionElement;
};

/** Autogenerated return type of SetChartOption. */
export type SetChartOptionPayload = {
  __typename?: 'SetChartOptionPayload';
  chartOption?: Maybe<ChartOption>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Autogenerated input type of SetReportFavorite */
export type SetReportFavoriteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  type: ReportFavoriteElement;
};

/** Autogenerated return type of SetReportFavorite. */
export type SetReportFavoritePayload = {
  __typename?: 'SetReportFavoritePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  reportFavorite?: Maybe<ReportFavorite>;
  success: Scalars['Boolean'];
};

export type ShareInput = {
  emails: Scalars['String'];
  includeFavorites: Scalars['Boolean'];
  reportIds: Array<Scalars['ID']>;
};

/** Autogenerated input type of ShareReports */
export type ShareReportsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: ShareInput;
};

/** Autogenerated return type of ShareReports. */
export type ShareReportsPayload = {
  __typename?: 'ShareReportsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  messagePage: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ReportTagsFieldsFragment = { __typename?: 'ReportTags', surveyType: Array<string>, reportTypeTags: Array<string>, yearTags: Array<string>, levelTags: Array<string>, schoolTags: Array<string>, districtTags: Array<string>, commentsTags: Array<string> };

export type ReportFieldsFragment = { __typename?: 'Report', id: string, title?: string | null, reportType?: string | null, publishedYear?: string | null, cohorts: Array<string>, subgroups: Array<string>, data?: any | null, canPresent: boolean, surveyType?: string | null, schoolName?: string | null, chartOption?: { __typename?: 'ChartOption', id: string, cohort?: string | null, subgroup?: string | null, pastResults?: boolean | null, config?: any | null, entityType: string } | null, tags: { __typename?: 'ReportTags', surveyType: Array<string>, reportTypeTags: Array<string>, yearTags: Array<string>, levelTags: Array<string>, schoolTags: Array<string>, districtTags: Array<string>, commentsTags: Array<string> }, downloadMaterials: Array<{ __typename?: 'DownloadMaterial', id: string, title?: string | null, path: string }>, scrapedDownloadMaterials: Array<{ __typename?: 'ScrapedDownloadMaterial', linkText?: string | null, cleanedLink?: string | null }> };

export type SimpleReportFieldsFragment = { __typename?: 'Report', id: string, title?: string | null, reportType?: string | null, publishedYear?: string | null, cohorts: Array<string>, subgroups: Array<string>, surveyType?: string | null, schoolName?: string | null, canManage: boolean, tags: { __typename?: 'ReportTags', surveyType: Array<string>, reportTypeTags: Array<string>, yearTags: Array<string>, levelTags: Array<string>, schoolTags: Array<string>, districtTags: Array<string>, commentsTags: Array<string> } };

export type ReportWithFavoritesFieldsFragment = { __typename?: 'ReportWithFavorites', id: string, title?: string | null, reportType?: string | null, publishedYear?: string | null, cohorts: Array<string>, subgroups: Array<string>, data?: any | null, canPresent: boolean, surveyType?: string | null, schoolName?: string | null, chartOption?: { __typename?: 'ChartOption', id: string, cohort?: string | null, subgroup?: string | null, pastResults?: boolean | null, config?: any | null, entityType: string } | null, tags: { __typename?: 'ReportTags', surveyType: Array<string>, reportTypeTags: Array<string>, yearTags: Array<string>, levelTags: Array<string>, schoolTags: Array<string>, districtTags: Array<string>, commentsTags: Array<string> }, downloadMaterials: Array<{ __typename?: 'DownloadMaterial', id: string, title?: string | null, path: string }>, scrapedDownloadMaterials: Array<{ __typename?: 'ScrapedDownloadMaterial', linkText?: string | null, cleanedLink?: string | null }> };

export type DownloadMaterialFieldsFragment = { __typename?: 'DownloadMaterial', id: string, title?: string | null, path: string };

export type ScrapedDownloadMaterialsFieldsFragment = { __typename?: 'ScrapedDownloadMaterial', linkText?: string | null, cleanedLink?: string | null };

export type ChartOptionFieldsFragment = { __typename?: 'ChartOption', id: string, cohort?: string | null, subgroup?: string | null, pastResults?: boolean | null, config?: any | null, entityType: string };

export type ReportSectionFieldsFragment = { __typename?: 'ReportSection', id: string, parentReportSectionId?: string | null, title?: string | null, hasChildFavorites: boolean, hasElementFavorites: boolean, hasAllElementFavorites: boolean, reportFavorite?: { __typename?: 'ReportFavorite', id: string } | null };

export type ReportElementFieldsFragment = { __typename?: 'ReportElement', id: string, contentType: string, content?: string | null, hasSectionFavorite: boolean, chartOption?: { __typename?: 'ChartOption', id: string, cohort?: string | null, subgroup?: string | null, pastResults?: boolean | null, config?: any | null, entityType: string } | null, reportFavorite?: { __typename?: 'ReportFavorite', id: string } | null };

export type ReportFavoriteFieldsFragment = { __typename?: 'ReportFavorite', id: string };

export type SearchHitFieldsFragment = { __typename?: 'SearchHit', title: string, match: string, reportId: string, sectionId?: string | null };

export type GetReportDetailsFragmentFragment = { __typename?: 'Report', id: string, title?: string | null, reportType?: string | null, publishedYear?: string | null, cohorts: Array<string>, subgroups: Array<string>, data?: any | null, canPresent: boolean, surveyType?: string | null, schoolName?: string | null, sections: Array<{ __typename?: 'ReportSection', id: string, parentReportSectionId?: string | null, title?: string | null, hasChildFavorites: boolean, hasElementFavorites: boolean, hasAllElementFavorites: boolean, reportFavorite?: { __typename?: 'ReportFavorite', id: string } | null }>, chartOption?: { __typename?: 'ChartOption', id: string, cohort?: string | null, subgroup?: string | null, pastResults?: boolean | null, config?: any | null, entityType: string } | null, tags: { __typename?: 'ReportTags', surveyType: Array<string>, reportTypeTags: Array<string>, yearTags: Array<string>, levelTags: Array<string>, schoolTags: Array<string>, districtTags: Array<string>, commentsTags: Array<string> }, downloadMaterials: Array<{ __typename?: 'DownloadMaterial', id: string, title?: string | null, path: string }>, scrapedDownloadMaterials: Array<{ __typename?: 'ScrapedDownloadMaterial', linkText?: string | null, cleanedLink?: string | null }> };

export type GetReportWithFavoritesDetailsFragmentFragment = { __typename?: 'ReportWithFavorites', id: string, title?: string | null, reportType?: string | null, publishedYear?: string | null, cohorts: Array<string>, subgroups: Array<string>, data?: any | null, canPresent: boolean, surveyType?: string | null, schoolName?: string | null, sections: Array<{ __typename?: 'ReportSection', id: string, parentReportSectionId?: string | null, title?: string | null, hasChildFavorites: boolean, hasElementFavorites: boolean, hasAllElementFavorites: boolean, reportFavorite?: { __typename?: 'ReportFavorite', id: string } | null }>, chartOption?: { __typename?: 'ChartOption', id: string, cohort?: string | null, subgroup?: string | null, pastResults?: boolean | null, config?: any | null, entityType: string } | null, tags: { __typename?: 'ReportTags', surveyType: Array<string>, reportTypeTags: Array<string>, yearTags: Array<string>, levelTags: Array<string>, schoolTags: Array<string>, districtTags: Array<string>, commentsTags: Array<string> }, downloadMaterials: Array<{ __typename?: 'DownloadMaterial', id: string, title?: string | null, path: string }>, scrapedDownloadMaterials: Array<{ __typename?: 'ScrapedDownloadMaterial', linkText?: string | null, cleanedLink?: string | null }> };

export type GetReportYearsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportYearsQuery = { __typename?: 'Query', reportYears: Array<number> };

export type GetReportsPageCountQueryVariables = Exact<{
  perPage: Scalars['Int'];
}>;


export type GetReportsPageCountQuery = { __typename?: 'Query', reportsPageCount: { __typename?: 'ReportsCount', totalCount: number, totalPages: number } };

export type GetManagedReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManagedReportsQuery = { __typename?: 'Query', managedReports: Array<{ __typename?: 'ReportManager', reportId: string }> };

export type GetManagedReportsByYearQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type GetManagedReportsByYearQuery = { __typename?: 'Query', managedReportsByYear: Array<{ __typename?: 'ReportManager', reportId: string }> };

export type GetReportsTaggingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportsTaggingsQuery = { __typename?: 'Query', reportsTaggings: Array<{ __typename?: 'ReportTagging', reportId: string, tags: { __typename?: 'ReportTags', surveyType: Array<string>, reportTypeTags: Array<string>, yearTags: Array<string>, levelTags: Array<string>, schoolTags: Array<string>, districtTags: Array<string>, commentsTags: Array<string> } }> };

export type GetReportTaggingsByYearQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type GetReportTaggingsByYearQuery = { __typename?: 'Query', reportTaggingsByYear: Array<{ __typename?: 'ReportTagging', reportId: string, tags: { __typename?: 'ReportTags', surveyType: Array<string>, reportTypeTags: Array<string>, yearTags: Array<string>, levelTags: Array<string>, schoolTags: Array<string>, districtTags: Array<string>, commentsTags: Array<string> } }> };

export type GetReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportsQuery = { __typename?: 'Query', reports: Array<{ __typename?: 'ReportListItem', id: string, title?: string | null }> };

export type GetReportsByYearQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type GetReportsByYearQuery = { __typename?: 'Query', reportsByYear: Array<{ __typename?: 'ReportListItem', id: string, title?: string | null }> };

export type GetPagedReportsQueryVariables = Exact<{
  page: Scalars['Int'];
  perPage: Scalars['Int'];
}>;


export type GetPagedReportsQuery = { __typename?: 'Query', pagedReports: Array<{ __typename?: 'ReportListItem', id: string, title?: string | null }> };

export type GetReportDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetReportDetailsQuery = { __typename?: 'Query', report?: { __typename?: 'Report', id: string, title?: string | null, reportType?: string | null, publishedYear?: string | null, cohorts: Array<string>, subgroups: Array<string>, data?: any | null, canPresent: boolean, surveyType?: string | null, schoolName?: string | null, sections: Array<{ __typename?: 'ReportSection', id: string, parentReportSectionId?: string | null, title?: string | null, hasChildFavorites: boolean, hasElementFavorites: boolean, hasAllElementFavorites: boolean, reportFavorite?: { __typename?: 'ReportFavorite', id: string } | null }>, chartOption?: { __typename?: 'ChartOption', id: string, cohort?: string | null, subgroup?: string | null, pastResults?: boolean | null, config?: any | null, entityType: string } | null, tags: { __typename?: 'ReportTags', surveyType: Array<string>, reportTypeTags: Array<string>, yearTags: Array<string>, levelTags: Array<string>, schoolTags: Array<string>, districtTags: Array<string>, commentsTags: Array<string> }, downloadMaterials: Array<{ __typename?: 'DownloadMaterial', id: string, title?: string | null, path: string }>, scrapedDownloadMaterials: Array<{ __typename?: 'ScrapedDownloadMaterial', linkText?: string | null, cleanedLink?: string | null }> } | null };

export type GetReportFavoriteDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetReportFavoriteDetailsQuery = { __typename?: 'Query', reportWithFavorites?: { __typename?: 'ReportWithFavorites', id: string, title?: string | null, reportType?: string | null, publishedYear?: string | null, cohorts: Array<string>, subgroups: Array<string>, data?: any | null, canPresent: boolean, surveyType?: string | null, schoolName?: string | null, sections: Array<{ __typename?: 'ReportSection', id: string, parentReportSectionId?: string | null, title?: string | null, hasChildFavorites: boolean, hasElementFavorites: boolean, hasAllElementFavorites: boolean, reportFavorite?: { __typename?: 'ReportFavorite', id: string } | null }>, chartOption?: { __typename?: 'ChartOption', id: string, cohort?: string | null, subgroup?: string | null, pastResults?: boolean | null, config?: any | null, entityType: string } | null, tags: { __typename?: 'ReportTags', surveyType: Array<string>, reportTypeTags: Array<string>, yearTags: Array<string>, levelTags: Array<string>, schoolTags: Array<string>, districtTags: Array<string>, commentsTags: Array<string> }, downloadMaterials: Array<{ __typename?: 'DownloadMaterial', id: string, title?: string | null, path: string }>, scrapedDownloadMaterials: Array<{ __typename?: 'ScrapedDownloadMaterial', linkText?: string | null, cleanedLink?: string | null }> } | null };

export type GetReportElementsQueryVariables = Exact<{
  reportId: Scalars['ID'];
  sectionId: Scalars['ID'];
}>;


export type GetReportElementsQuery = { __typename?: 'Query', reportElements: Array<{ __typename?: 'ReportElement', id: string, contentType: string, content?: string | null, hasSectionFavorite: boolean, chartOption?: { __typename?: 'ChartOption', id: string, cohort?: string | null, subgroup?: string | null, pastResults?: boolean | null, config?: any | null, entityType: string } | null, reportFavorite?: { __typename?: 'ReportFavorite', id: string } | null }> };

export type GetPrintReportElementsQueryVariables = Exact<{
  reportId: Scalars['ID'];
  sectionId: Scalars['ID'];
}>;


export type GetPrintReportElementsQuery = { __typename?: 'Query', printReportElements: Array<{ __typename?: 'ReportElement', id: string, contentType: string, content?: string | null, hasSectionFavorite: boolean, chartOption?: { __typename?: 'ChartOption', id: string, cohort?: string | null, subgroup?: string | null, pastResults?: boolean | null, config?: any | null, entityType: string } | null, reportFavorite?: { __typename?: 'ReportFavorite', id: string } | null }> };

export type GetReportFavoriteElementsQueryVariables = Exact<{
  reportId: Scalars['ID'];
  sectionId: Scalars['ID'];
}>;


export type GetReportFavoriteElementsQuery = { __typename?: 'Query', reportFavoriteElements: Array<{ __typename?: 'ReportElement', id: string, contentType: string, content?: string | null, hasSectionFavorite: boolean, chartOption?: { __typename?: 'ChartOption', id: string, cohort?: string | null, subgroup?: string | null, pastResults?: boolean | null, config?: any | null, entityType: string } | null, reportFavorite?: { __typename?: 'ReportFavorite', id: string } | null }> };

export type SearchReportsQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchReportsQuery = { __typename?: 'Query', searchReports: Array<{ __typename?: 'SearchHit', title: string, match: string, reportId: string, sectionId?: string | null }> };

export type SearchSectionsQueryVariables = Exact<{
  query: Scalars['String'];
  reportId: Scalars['String'];
}>;


export type SearchSectionsQuery = { __typename?: 'Query', searchSections: Array<{ __typename?: 'SearchHit', title: string, match: string, reportId: string, sectionId?: string | null }> };

export type GetChartOptionQueryVariables = Exact<{
  id: Scalars['ID'];
  type: ChartOptionElement;
}>;


export type GetChartOptionQuery = { __typename?: 'Query', chartOption?: { __typename?: 'ChartOption', id: string, cohort?: string | null, subgroup?: string | null, pastResults?: boolean | null, config?: any | null, entityType: string } | null };

export type GetReportFavoriteQueryVariables = Exact<{
  id: Scalars['ID'];
  type: ReportFavoriteElement;
}>;


export type GetReportFavoriteQuery = { __typename?: 'Query', reportFavorite?: { __typename?: 'ReportFavorite', id: string } | null };

export type GetPdfReportQueryVariables = Exact<{
  randomKey: Scalars['String'];
}>;


export type GetPdfReportQuery = { __typename?: 'Query', pdfReport?: { __typename?: 'PdfReport', id: string, randomKey: string, status: string, percentComplete: number } | null };

export type GetPdfReportSectionQueryVariables = Exact<{
  sectionId: Scalars['ID'];
  favorites: Scalars['Boolean'];
}>;


export type GetPdfReportSectionQuery = { __typename?: 'Query', pdfReportSection: { __typename?: 'PdfReportSection', reportSection: { __typename?: 'ReportSection', id: string, parentReportSectionId?: string | null, title?: string | null, hasChildFavorites: boolean, hasElementFavorites: boolean, hasAllElementFavorites: boolean, reportFavorite?: { __typename?: 'ReportFavorite', id: string } | null }, childReportSections: Array<{ __typename?: 'ReportSection', id: string, parentReportSectionId?: string | null, title?: string | null, hasChildFavorites: boolean, hasElementFavorites: boolean, hasAllElementFavorites: boolean, reportFavorite?: { __typename?: 'ReportFavorite', id: string } | null }> } };

export type ShareReportsMutationVariables = Exact<{
  input: ShareInput;
}>;


export type ShareReportsMutation = { __typename?: 'Mutation', shareReports?: { __typename?: 'ShareReportsPayload', message: string, success: boolean, messagePage: string } | null };

export type SetReportFavoriteMutationVariables = Exact<{
  id: Scalars['ID'];
  type: ReportFavoriteElement;
}>;


export type SetReportFavoriteMutation = { __typename?: 'Mutation', setReportFavorite?: { __typename?: 'SetReportFavoritePayload', message: string, success: boolean, reportFavorite?: { __typename?: 'ReportFavorite', id: string } | null } | null };

export type RemoveReportFavoriteMutationVariables = Exact<{
  id: Scalars['ID'];
  type: ReportFavoriteElement;
}>;


export type RemoveReportFavoriteMutation = { __typename?: 'Mutation', removeReportFavorite?: { __typename?: 'RemoveReportFavoritePayload', message: string, success: boolean } | null };

export type SetChartOptionMutationVariables = Exact<{
  id: Scalars['ID'];
  type: ChartOptionElement;
  input: ChartOptionInput;
}>;


export type SetChartOptionMutation = { __typename?: 'Mutation', setChartOption?: { __typename?: 'SetChartOptionPayload', message: string, success: boolean, chartOption?: { __typename?: 'ChartOption', id: string, cohort?: string | null, subgroup?: string | null, pastResults?: boolean | null, config?: any | null, entityType: string } | null } | null };

export type RemoveChartOptionMutationVariables = Exact<{
  id: Scalars['ID'];
  type: ChartOptionElement;
}>;


export type RemoveChartOptionMutation = { __typename?: 'Mutation', removeChartOption?: { __typename?: 'RemoveChartOptionPayload', message: string, success: boolean } | null };

export type ResetChartOptionsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResetChartOptionsMutation = { __typename?: 'Mutation', resetChartOptions?: { __typename?: 'ResetChartOptionsPayload', message: string, success: boolean } | null };

export type CreateChartUriMutationVariables = Exact<{
  input: ChartUriInput;
}>;


export type CreateChartUriMutation = { __typename?: 'Mutation', createChartUri?: { __typename?: 'CreateChartUriPayload', success: boolean, message: string, chartUri?: { __typename?: 'ChartUri', id: string, base64: string, title: string } | null } | null };

export type CreatePdfReportMutationVariables = Exact<{
  input: PdfReportInput;
}>;


export type CreatePdfReportMutation = { __typename?: 'Mutation', createPdfReport?: { __typename?: 'CreatePdfReportPayload', success: boolean, message: string, pdfReport?: { __typename?: 'PdfReport', id: string, randomKey: string, status: string, percentComplete: number } | null } | null };

export const ReportTagsFieldsFragmentDoc = gql`
    fragment ReportTagsFields on ReportTags {
  surveyType
  reportTypeTags
  yearTags
  levelTags
  schoolTags
  districtTags
  commentsTags
}
    `;
export const SimpleReportFieldsFragmentDoc = gql`
    fragment SimpleReportFields on Report {
  id
  title
  reportType
  publishedYear
  cohorts
  subgroups
  surveyType
  schoolName
  canManage
  tags {
    ...ReportTagsFields
  }
}
    ${ReportTagsFieldsFragmentDoc}`;
export const ChartOptionFieldsFragmentDoc = gql`
    fragment ChartOptionFields on ChartOption {
  id
  cohort
  subgroup
  pastResults
  config
  entityType
}
    `;
export const ReportFavoriteFieldsFragmentDoc = gql`
    fragment ReportFavoriteFields on ReportFavorite {
  id
}
    `;
export const ReportElementFieldsFragmentDoc = gql`
    fragment ReportElementFields on ReportElement {
  id
  contentType
  content
  hasSectionFavorite
  chartOption {
    ...ChartOptionFields
  }
  reportFavorite {
    ...ReportFavoriteFields
  }
}
    ${ChartOptionFieldsFragmentDoc}
${ReportFavoriteFieldsFragmentDoc}`;
export const SearchHitFieldsFragmentDoc = gql`
    fragment SearchHitFields on SearchHit {
  title
  match
  reportId
  sectionId
}
    `;
export const DownloadMaterialFieldsFragmentDoc = gql`
    fragment DownloadMaterialFields on DownloadMaterial {
  id
  title
  path
}
    `;
export const ScrapedDownloadMaterialsFieldsFragmentDoc = gql`
    fragment ScrapedDownloadMaterialsFields on ScrapedDownloadMaterial {
  linkText
  cleanedLink
}
    `;
export const ReportFieldsFragmentDoc = gql`
    fragment ReportFields on Report {
  id
  title
  reportType
  publishedYear
  cohorts
  subgroups
  data
  canPresent
  surveyType
  schoolName
  chartOption {
    ...ChartOptionFields
  }
  tags {
    ...ReportTagsFields
  }
  downloadMaterials {
    ...DownloadMaterialFields
  }
  scrapedDownloadMaterials {
    ...ScrapedDownloadMaterialsFields
  }
}
    ${ChartOptionFieldsFragmentDoc}
${ReportTagsFieldsFragmentDoc}
${DownloadMaterialFieldsFragmentDoc}
${ScrapedDownloadMaterialsFieldsFragmentDoc}`;
export const ReportSectionFieldsFragmentDoc = gql`
    fragment ReportSectionFields on ReportSection {
  id
  parentReportSectionId
  title
  hasChildFavorites
  hasElementFavorites
  hasAllElementFavorites
  reportFavorite {
    ...ReportFavoriteFields
  }
}
    ${ReportFavoriteFieldsFragmentDoc}`;
export const GetReportDetailsFragmentFragmentDoc = gql`
    fragment GetReportDetailsFragment on Report {
  ...ReportFields
  sections {
    ...ReportSectionFields
  }
}
    ${ReportFieldsFragmentDoc}
${ReportSectionFieldsFragmentDoc}`;
export const ReportWithFavoritesFieldsFragmentDoc = gql`
    fragment ReportWithFavoritesFields on ReportWithFavorites {
  id
  title
  reportType
  publishedYear
  cohorts
  subgroups
  data
  canPresent
  surveyType
  schoolName
  chartOption {
    ...ChartOptionFields
  }
  tags {
    ...ReportTagsFields
  }
  downloadMaterials {
    ...DownloadMaterialFields
  }
  scrapedDownloadMaterials {
    ...ScrapedDownloadMaterialsFields
  }
}
    ${ChartOptionFieldsFragmentDoc}
${ReportTagsFieldsFragmentDoc}
${DownloadMaterialFieldsFragmentDoc}
${ScrapedDownloadMaterialsFieldsFragmentDoc}`;
export const GetReportWithFavoritesDetailsFragmentFragmentDoc = gql`
    fragment GetReportWithFavoritesDetailsFragment on ReportWithFavorites {
  ...ReportWithFavoritesFields
  sections {
    ...ReportSectionFields
  }
}
    ${ReportWithFavoritesFieldsFragmentDoc}
${ReportSectionFieldsFragmentDoc}`;
export const GetReportYearsDocument = gql`
    query GetReportYears {
  reportYears
}
    `;

/**
 * __useGetReportYearsQuery__
 *
 * To run a query within a React component, call `useGetReportYearsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportYearsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportYearsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportYearsQuery(baseOptions?: Apollo.QueryHookOptions<GetReportYearsQuery, GetReportYearsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportYearsQuery, GetReportYearsQueryVariables>(GetReportYearsDocument, options);
      }
export function useGetReportYearsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportYearsQuery, GetReportYearsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportYearsQuery, GetReportYearsQueryVariables>(GetReportYearsDocument, options);
        }
export type GetReportYearsQueryHookResult = ReturnType<typeof useGetReportYearsQuery>;
export type GetReportYearsLazyQueryHookResult = ReturnType<typeof useGetReportYearsLazyQuery>;
export type GetReportYearsQueryResult = Apollo.QueryResult<GetReportYearsQuery, GetReportYearsQueryVariables>;
export const GetReportsPageCountDocument = gql`
    query GetReportsPageCount($perPage: Int!) {
  reportsPageCount(perPage: $perPage) {
    totalCount
    totalPages
  }
}
    `;

/**
 * __useGetReportsPageCountQuery__
 *
 * To run a query within a React component, call `useGetReportsPageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsPageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsPageCountQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetReportsPageCountQuery(baseOptions: Apollo.QueryHookOptions<GetReportsPageCountQuery, GetReportsPageCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsPageCountQuery, GetReportsPageCountQueryVariables>(GetReportsPageCountDocument, options);
      }
export function useGetReportsPageCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsPageCountQuery, GetReportsPageCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsPageCountQuery, GetReportsPageCountQueryVariables>(GetReportsPageCountDocument, options);
        }
export type GetReportsPageCountQueryHookResult = ReturnType<typeof useGetReportsPageCountQuery>;
export type GetReportsPageCountLazyQueryHookResult = ReturnType<typeof useGetReportsPageCountLazyQuery>;
export type GetReportsPageCountQueryResult = Apollo.QueryResult<GetReportsPageCountQuery, GetReportsPageCountQueryVariables>;
export const GetManagedReportsDocument = gql`
    query GetManagedReports {
  managedReports {
    reportId
  }
}
    `;

/**
 * __useGetManagedReportsQuery__
 *
 * To run a query within a React component, call `useGetManagedReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagedReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagedReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagedReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetManagedReportsQuery, GetManagedReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagedReportsQuery, GetManagedReportsQueryVariables>(GetManagedReportsDocument, options);
      }
export function useGetManagedReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagedReportsQuery, GetManagedReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagedReportsQuery, GetManagedReportsQueryVariables>(GetManagedReportsDocument, options);
        }
export type GetManagedReportsQueryHookResult = ReturnType<typeof useGetManagedReportsQuery>;
export type GetManagedReportsLazyQueryHookResult = ReturnType<typeof useGetManagedReportsLazyQuery>;
export type GetManagedReportsQueryResult = Apollo.QueryResult<GetManagedReportsQuery, GetManagedReportsQueryVariables>;
export const GetManagedReportsByYearDocument = gql`
    query GetManagedReportsByYear($year: Int!) {
  managedReportsByYear(year: $year) {
    reportId
  }
}
    `;

/**
 * __useGetManagedReportsByYearQuery__
 *
 * To run a query within a React component, call `useGetManagedReportsByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagedReportsByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagedReportsByYearQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetManagedReportsByYearQuery(baseOptions: Apollo.QueryHookOptions<GetManagedReportsByYearQuery, GetManagedReportsByYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagedReportsByYearQuery, GetManagedReportsByYearQueryVariables>(GetManagedReportsByYearDocument, options);
      }
export function useGetManagedReportsByYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagedReportsByYearQuery, GetManagedReportsByYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagedReportsByYearQuery, GetManagedReportsByYearQueryVariables>(GetManagedReportsByYearDocument, options);
        }
export type GetManagedReportsByYearQueryHookResult = ReturnType<typeof useGetManagedReportsByYearQuery>;
export type GetManagedReportsByYearLazyQueryHookResult = ReturnType<typeof useGetManagedReportsByYearLazyQuery>;
export type GetManagedReportsByYearQueryResult = Apollo.QueryResult<GetManagedReportsByYearQuery, GetManagedReportsByYearQueryVariables>;
export const GetReportsTaggingsDocument = gql`
    query GetReportsTaggings {
  reportsTaggings {
    reportId
    tags {
      ...ReportTagsFields
    }
  }
}
    ${ReportTagsFieldsFragmentDoc}`;

/**
 * __useGetReportsTaggingsQuery__
 *
 * To run a query within a React component, call `useGetReportsTaggingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsTaggingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsTaggingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportsTaggingsQuery(baseOptions?: Apollo.QueryHookOptions<GetReportsTaggingsQuery, GetReportsTaggingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsTaggingsQuery, GetReportsTaggingsQueryVariables>(GetReportsTaggingsDocument, options);
      }
export function useGetReportsTaggingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsTaggingsQuery, GetReportsTaggingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsTaggingsQuery, GetReportsTaggingsQueryVariables>(GetReportsTaggingsDocument, options);
        }
export type GetReportsTaggingsQueryHookResult = ReturnType<typeof useGetReportsTaggingsQuery>;
export type GetReportsTaggingsLazyQueryHookResult = ReturnType<typeof useGetReportsTaggingsLazyQuery>;
export type GetReportsTaggingsQueryResult = Apollo.QueryResult<GetReportsTaggingsQuery, GetReportsTaggingsQueryVariables>;
export const GetReportTaggingsByYearDocument = gql`
    query GetReportTaggingsByYear($year: Int!) {
  reportTaggingsByYear(year: $year) {
    reportId
    tags {
      ...ReportTagsFields
    }
  }
}
    ${ReportTagsFieldsFragmentDoc}`;

/**
 * __useGetReportTaggingsByYearQuery__
 *
 * To run a query within a React component, call `useGetReportTaggingsByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTaggingsByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTaggingsByYearQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetReportTaggingsByYearQuery(baseOptions: Apollo.QueryHookOptions<GetReportTaggingsByYearQuery, GetReportTaggingsByYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportTaggingsByYearQuery, GetReportTaggingsByYearQueryVariables>(GetReportTaggingsByYearDocument, options);
      }
export function useGetReportTaggingsByYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportTaggingsByYearQuery, GetReportTaggingsByYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportTaggingsByYearQuery, GetReportTaggingsByYearQueryVariables>(GetReportTaggingsByYearDocument, options);
        }
export type GetReportTaggingsByYearQueryHookResult = ReturnType<typeof useGetReportTaggingsByYearQuery>;
export type GetReportTaggingsByYearLazyQueryHookResult = ReturnType<typeof useGetReportTaggingsByYearLazyQuery>;
export type GetReportTaggingsByYearQueryResult = Apollo.QueryResult<GetReportTaggingsByYearQuery, GetReportTaggingsByYearQueryVariables>;
export const GetReportsDocument = gql`
    query GetReports {
  reports {
    id
    title
  }
}
    `;

/**
 * __useGetReportsQuery__
 *
 * To run a query within a React component, call `useGetReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetReportsQuery, GetReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
      }
export function useGetReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsQuery, GetReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
        }
export type GetReportsQueryHookResult = ReturnType<typeof useGetReportsQuery>;
export type GetReportsLazyQueryHookResult = ReturnType<typeof useGetReportsLazyQuery>;
export type GetReportsQueryResult = Apollo.QueryResult<GetReportsQuery, GetReportsQueryVariables>;
export const GetReportsByYearDocument = gql`
    query GetReportsByYear($year: Int!) {
  reportsByYear(year: $year) {
    id
    title
  }
}
    `;

/**
 * __useGetReportsByYearQuery__
 *
 * To run a query within a React component, call `useGetReportsByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsByYearQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetReportsByYearQuery(baseOptions: Apollo.QueryHookOptions<GetReportsByYearQuery, GetReportsByYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsByYearQuery, GetReportsByYearQueryVariables>(GetReportsByYearDocument, options);
      }
export function useGetReportsByYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsByYearQuery, GetReportsByYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsByYearQuery, GetReportsByYearQueryVariables>(GetReportsByYearDocument, options);
        }
export type GetReportsByYearQueryHookResult = ReturnType<typeof useGetReportsByYearQuery>;
export type GetReportsByYearLazyQueryHookResult = ReturnType<typeof useGetReportsByYearLazyQuery>;
export type GetReportsByYearQueryResult = Apollo.QueryResult<GetReportsByYearQuery, GetReportsByYearQueryVariables>;
export const GetPagedReportsDocument = gql`
    query GetPagedReports($page: Int!, $perPage: Int!) {
  pagedReports(page: $page, perPage: $perPage) {
    id
    title
  }
}
    `;

/**
 * __useGetPagedReportsQuery__
 *
 * To run a query within a React component, call `useGetPagedReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPagedReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPagedReportsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetPagedReportsQuery(baseOptions: Apollo.QueryHookOptions<GetPagedReportsQuery, GetPagedReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPagedReportsQuery, GetPagedReportsQueryVariables>(GetPagedReportsDocument, options);
      }
export function useGetPagedReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPagedReportsQuery, GetPagedReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPagedReportsQuery, GetPagedReportsQueryVariables>(GetPagedReportsDocument, options);
        }
export type GetPagedReportsQueryHookResult = ReturnType<typeof useGetPagedReportsQuery>;
export type GetPagedReportsLazyQueryHookResult = ReturnType<typeof useGetPagedReportsLazyQuery>;
export type GetPagedReportsQueryResult = Apollo.QueryResult<GetPagedReportsQuery, GetPagedReportsQueryVariables>;
export const GetReportDetailsDocument = gql`
    query GetReportDetails($id: ID!) {
  report(id: $id) {
    ...GetReportDetailsFragment
  }
}
    ${GetReportDetailsFragmentFragmentDoc}`;

/**
 * __useGetReportDetailsQuery__
 *
 * To run a query within a React component, call `useGetReportDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetReportDetailsQuery, GetReportDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportDetailsQuery, GetReportDetailsQueryVariables>(GetReportDetailsDocument, options);
      }
export function useGetReportDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportDetailsQuery, GetReportDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportDetailsQuery, GetReportDetailsQueryVariables>(GetReportDetailsDocument, options);
        }
export type GetReportDetailsQueryHookResult = ReturnType<typeof useGetReportDetailsQuery>;
export type GetReportDetailsLazyQueryHookResult = ReturnType<typeof useGetReportDetailsLazyQuery>;
export type GetReportDetailsQueryResult = Apollo.QueryResult<GetReportDetailsQuery, GetReportDetailsQueryVariables>;
export const GetReportFavoriteDetailsDocument = gql`
    query GetReportFavoriteDetails($id: ID!) {
  reportWithFavorites(id: $id) {
    ...GetReportWithFavoritesDetailsFragment
  }
}
    ${GetReportWithFavoritesDetailsFragmentFragmentDoc}`;

/**
 * __useGetReportFavoriteDetailsQuery__
 *
 * To run a query within a React component, call `useGetReportFavoriteDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportFavoriteDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportFavoriteDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportFavoriteDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetReportFavoriteDetailsQuery, GetReportFavoriteDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportFavoriteDetailsQuery, GetReportFavoriteDetailsQueryVariables>(GetReportFavoriteDetailsDocument, options);
      }
export function useGetReportFavoriteDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportFavoriteDetailsQuery, GetReportFavoriteDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportFavoriteDetailsQuery, GetReportFavoriteDetailsQueryVariables>(GetReportFavoriteDetailsDocument, options);
        }
export type GetReportFavoriteDetailsQueryHookResult = ReturnType<typeof useGetReportFavoriteDetailsQuery>;
export type GetReportFavoriteDetailsLazyQueryHookResult = ReturnType<typeof useGetReportFavoriteDetailsLazyQuery>;
export type GetReportFavoriteDetailsQueryResult = Apollo.QueryResult<GetReportFavoriteDetailsQuery, GetReportFavoriteDetailsQueryVariables>;
export const GetReportElementsDocument = gql`
    query GetReportElements($reportId: ID!, $sectionId: ID!) {
  reportElements(reportId: $reportId, sectionId: $sectionId) {
    ...ReportElementFields
  }
}
    ${ReportElementFieldsFragmentDoc}`;

/**
 * __useGetReportElementsQuery__
 *
 * To run a query within a React component, call `useGetReportElementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportElementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportElementsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useGetReportElementsQuery(baseOptions: Apollo.QueryHookOptions<GetReportElementsQuery, GetReportElementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportElementsQuery, GetReportElementsQueryVariables>(GetReportElementsDocument, options);
      }
export function useGetReportElementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportElementsQuery, GetReportElementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportElementsQuery, GetReportElementsQueryVariables>(GetReportElementsDocument, options);
        }
export type GetReportElementsQueryHookResult = ReturnType<typeof useGetReportElementsQuery>;
export type GetReportElementsLazyQueryHookResult = ReturnType<typeof useGetReportElementsLazyQuery>;
export type GetReportElementsQueryResult = Apollo.QueryResult<GetReportElementsQuery, GetReportElementsQueryVariables>;
export const GetPrintReportElementsDocument = gql`
    query GetPrintReportElements($reportId: ID!, $sectionId: ID!) {
  printReportElements(reportId: $reportId, sectionId: $sectionId) {
    ...ReportElementFields
  }
}
    ${ReportElementFieldsFragmentDoc}`;

/**
 * __useGetPrintReportElementsQuery__
 *
 * To run a query within a React component, call `useGetPrintReportElementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrintReportElementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrintReportElementsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useGetPrintReportElementsQuery(baseOptions: Apollo.QueryHookOptions<GetPrintReportElementsQuery, GetPrintReportElementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrintReportElementsQuery, GetPrintReportElementsQueryVariables>(GetPrintReportElementsDocument, options);
      }
export function useGetPrintReportElementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrintReportElementsQuery, GetPrintReportElementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrintReportElementsQuery, GetPrintReportElementsQueryVariables>(GetPrintReportElementsDocument, options);
        }
export type GetPrintReportElementsQueryHookResult = ReturnType<typeof useGetPrintReportElementsQuery>;
export type GetPrintReportElementsLazyQueryHookResult = ReturnType<typeof useGetPrintReportElementsLazyQuery>;
export type GetPrintReportElementsQueryResult = Apollo.QueryResult<GetPrintReportElementsQuery, GetPrintReportElementsQueryVariables>;
export const GetReportFavoriteElementsDocument = gql`
    query GetReportFavoriteElements($reportId: ID!, $sectionId: ID!) {
  reportFavoriteElements(reportId: $reportId, sectionId: $sectionId) {
    ...ReportElementFields
  }
}
    ${ReportElementFieldsFragmentDoc}`;

/**
 * __useGetReportFavoriteElementsQuery__
 *
 * To run a query within a React component, call `useGetReportFavoriteElementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportFavoriteElementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportFavoriteElementsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useGetReportFavoriteElementsQuery(baseOptions: Apollo.QueryHookOptions<GetReportFavoriteElementsQuery, GetReportFavoriteElementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportFavoriteElementsQuery, GetReportFavoriteElementsQueryVariables>(GetReportFavoriteElementsDocument, options);
      }
export function useGetReportFavoriteElementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportFavoriteElementsQuery, GetReportFavoriteElementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportFavoriteElementsQuery, GetReportFavoriteElementsQueryVariables>(GetReportFavoriteElementsDocument, options);
        }
export type GetReportFavoriteElementsQueryHookResult = ReturnType<typeof useGetReportFavoriteElementsQuery>;
export type GetReportFavoriteElementsLazyQueryHookResult = ReturnType<typeof useGetReportFavoriteElementsLazyQuery>;
export type GetReportFavoriteElementsQueryResult = Apollo.QueryResult<GetReportFavoriteElementsQuery, GetReportFavoriteElementsQueryVariables>;
export const SearchReportsDocument = gql`
    query SearchReports($query: String!) {
  searchReports(query: $query) {
    ...SearchHitFields
  }
}
    ${SearchHitFieldsFragmentDoc}`;

/**
 * __useSearchReportsQuery__
 *
 * To run a query within a React component, call `useSearchReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchReportsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchReportsQuery(baseOptions: Apollo.QueryHookOptions<SearchReportsQuery, SearchReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchReportsQuery, SearchReportsQueryVariables>(SearchReportsDocument, options);
      }
export function useSearchReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchReportsQuery, SearchReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchReportsQuery, SearchReportsQueryVariables>(SearchReportsDocument, options);
        }
export type SearchReportsQueryHookResult = ReturnType<typeof useSearchReportsQuery>;
export type SearchReportsLazyQueryHookResult = ReturnType<typeof useSearchReportsLazyQuery>;
export type SearchReportsQueryResult = Apollo.QueryResult<SearchReportsQuery, SearchReportsQueryVariables>;
export const SearchSectionsDocument = gql`
    query SearchSections($query: String!, $reportId: String!) {
  searchSections(query: $query, reportId: $reportId) {
    ...SearchHitFields
  }
}
    ${SearchHitFieldsFragmentDoc}`;

/**
 * __useSearchSectionsQuery__
 *
 * To run a query within a React component, call `useSearchSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSectionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useSearchSectionsQuery(baseOptions: Apollo.QueryHookOptions<SearchSectionsQuery, SearchSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSectionsQuery, SearchSectionsQueryVariables>(SearchSectionsDocument, options);
      }
export function useSearchSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSectionsQuery, SearchSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSectionsQuery, SearchSectionsQueryVariables>(SearchSectionsDocument, options);
        }
export type SearchSectionsQueryHookResult = ReturnType<typeof useSearchSectionsQuery>;
export type SearchSectionsLazyQueryHookResult = ReturnType<typeof useSearchSectionsLazyQuery>;
export type SearchSectionsQueryResult = Apollo.QueryResult<SearchSectionsQuery, SearchSectionsQueryVariables>;
export const GetChartOptionDocument = gql`
    query GetChartOption($id: ID!, $type: ChartOptionElement!) {
  chartOption(id: $id, type: $type) {
    ...ChartOptionFields
  }
}
    ${ChartOptionFieldsFragmentDoc}`;

/**
 * __useGetChartOptionQuery__
 *
 * To run a query within a React component, call `useGetChartOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChartOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChartOptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetChartOptionQuery(baseOptions: Apollo.QueryHookOptions<GetChartOptionQuery, GetChartOptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChartOptionQuery, GetChartOptionQueryVariables>(GetChartOptionDocument, options);
      }
export function useGetChartOptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChartOptionQuery, GetChartOptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChartOptionQuery, GetChartOptionQueryVariables>(GetChartOptionDocument, options);
        }
export type GetChartOptionQueryHookResult = ReturnType<typeof useGetChartOptionQuery>;
export type GetChartOptionLazyQueryHookResult = ReturnType<typeof useGetChartOptionLazyQuery>;
export type GetChartOptionQueryResult = Apollo.QueryResult<GetChartOptionQuery, GetChartOptionQueryVariables>;
export const GetReportFavoriteDocument = gql`
    query GetReportFavorite($id: ID!, $type: ReportFavoriteElement!) {
  reportFavorite(id: $id, type: $type) {
    ...ReportFavoriteFields
  }
}
    ${ReportFavoriteFieldsFragmentDoc}`;

/**
 * __useGetReportFavoriteQuery__
 *
 * To run a query within a React component, call `useGetReportFavoriteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportFavoriteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportFavoriteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetReportFavoriteQuery(baseOptions: Apollo.QueryHookOptions<GetReportFavoriteQuery, GetReportFavoriteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportFavoriteQuery, GetReportFavoriteQueryVariables>(GetReportFavoriteDocument, options);
      }
export function useGetReportFavoriteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportFavoriteQuery, GetReportFavoriteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportFavoriteQuery, GetReportFavoriteQueryVariables>(GetReportFavoriteDocument, options);
        }
export type GetReportFavoriteQueryHookResult = ReturnType<typeof useGetReportFavoriteQuery>;
export type GetReportFavoriteLazyQueryHookResult = ReturnType<typeof useGetReportFavoriteLazyQuery>;
export type GetReportFavoriteQueryResult = Apollo.QueryResult<GetReportFavoriteQuery, GetReportFavoriteQueryVariables>;
export const GetPdfReportDocument = gql`
    query GetPdfReport($randomKey: String!) {
  pdfReport(randomKey: $randomKey) {
    id
    randomKey
    status
    percentComplete
  }
}
    `;

/**
 * __useGetPdfReportQuery__
 *
 * To run a query within a React component, call `useGetPdfReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPdfReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPdfReportQuery({
 *   variables: {
 *      randomKey: // value for 'randomKey'
 *   },
 * });
 */
export function useGetPdfReportQuery(baseOptions: Apollo.QueryHookOptions<GetPdfReportQuery, GetPdfReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPdfReportQuery, GetPdfReportQueryVariables>(GetPdfReportDocument, options);
      }
export function useGetPdfReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPdfReportQuery, GetPdfReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPdfReportQuery, GetPdfReportQueryVariables>(GetPdfReportDocument, options);
        }
export type GetPdfReportQueryHookResult = ReturnType<typeof useGetPdfReportQuery>;
export type GetPdfReportLazyQueryHookResult = ReturnType<typeof useGetPdfReportLazyQuery>;
export type GetPdfReportQueryResult = Apollo.QueryResult<GetPdfReportQuery, GetPdfReportQueryVariables>;
export const GetPdfReportSectionDocument = gql`
    query GetPdfReportSection($sectionId: ID!, $favorites: Boolean!) {
  pdfReportSection(sectionId: $sectionId, favorites: $favorites) {
    reportSection {
      ...ReportSectionFields
    }
    childReportSections {
      ...ReportSectionFields
    }
  }
}
    ${ReportSectionFieldsFragmentDoc}`;

/**
 * __useGetPdfReportSectionQuery__
 *
 * To run a query within a React component, call `useGetPdfReportSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPdfReportSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPdfReportSectionQuery({
 *   variables: {
 *      sectionId: // value for 'sectionId'
 *      favorites: // value for 'favorites'
 *   },
 * });
 */
export function useGetPdfReportSectionQuery(baseOptions: Apollo.QueryHookOptions<GetPdfReportSectionQuery, GetPdfReportSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPdfReportSectionQuery, GetPdfReportSectionQueryVariables>(GetPdfReportSectionDocument, options);
      }
export function useGetPdfReportSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPdfReportSectionQuery, GetPdfReportSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPdfReportSectionQuery, GetPdfReportSectionQueryVariables>(GetPdfReportSectionDocument, options);
        }
export type GetPdfReportSectionQueryHookResult = ReturnType<typeof useGetPdfReportSectionQuery>;
export type GetPdfReportSectionLazyQueryHookResult = ReturnType<typeof useGetPdfReportSectionLazyQuery>;
export type GetPdfReportSectionQueryResult = Apollo.QueryResult<GetPdfReportSectionQuery, GetPdfReportSectionQueryVariables>;
export const ShareReportsDocument = gql`
    mutation ShareReports($input: ShareInput!) {
  shareReports(input: {input: $input}) {
    message
    success
    messagePage
  }
}
    `;
export type ShareReportsMutationFn = Apollo.MutationFunction<ShareReportsMutation, ShareReportsMutationVariables>;

/**
 * __useShareReportsMutation__
 *
 * To run a mutation, you first call `useShareReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareReportsMutation, { data, loading, error }] = useShareReportsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareReportsMutation(baseOptions?: Apollo.MutationHookOptions<ShareReportsMutation, ShareReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareReportsMutation, ShareReportsMutationVariables>(ShareReportsDocument, options);
      }
export type ShareReportsMutationHookResult = ReturnType<typeof useShareReportsMutation>;
export type ShareReportsMutationResult = Apollo.MutationResult<ShareReportsMutation>;
export type ShareReportsMutationOptions = Apollo.BaseMutationOptions<ShareReportsMutation, ShareReportsMutationVariables>;
export const SetReportFavoriteDocument = gql`
    mutation SetReportFavorite($id: ID!, $type: ReportFavoriteElement!) {
  setReportFavorite(input: {id: $id, type: $type}) {
    message
    success
    reportFavorite {
      ...ReportFavoriteFields
    }
  }
}
    ${ReportFavoriteFieldsFragmentDoc}`;
export type SetReportFavoriteMutationFn = Apollo.MutationFunction<SetReportFavoriteMutation, SetReportFavoriteMutationVariables>;

/**
 * __useSetReportFavoriteMutation__
 *
 * To run a mutation, you first call `useSetReportFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReportFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReportFavoriteMutation, { data, loading, error }] = useSetReportFavoriteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSetReportFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<SetReportFavoriteMutation, SetReportFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReportFavoriteMutation, SetReportFavoriteMutationVariables>(SetReportFavoriteDocument, options);
      }
export type SetReportFavoriteMutationHookResult = ReturnType<typeof useSetReportFavoriteMutation>;
export type SetReportFavoriteMutationResult = Apollo.MutationResult<SetReportFavoriteMutation>;
export type SetReportFavoriteMutationOptions = Apollo.BaseMutationOptions<SetReportFavoriteMutation, SetReportFavoriteMutationVariables>;
export const RemoveReportFavoriteDocument = gql`
    mutation RemoveReportFavorite($id: ID!, $type: ReportFavoriteElement!) {
  removeReportFavorite(input: {id: $id, type: $type}) {
    message
    success
  }
}
    `;
export type RemoveReportFavoriteMutationFn = Apollo.MutationFunction<RemoveReportFavoriteMutation, RemoveReportFavoriteMutationVariables>;

/**
 * __useRemoveReportFavoriteMutation__
 *
 * To run a mutation, you first call `useRemoveReportFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReportFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeReportFavoriteMutation, { data, loading, error }] = useRemoveReportFavoriteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRemoveReportFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<RemoveReportFavoriteMutation, RemoveReportFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveReportFavoriteMutation, RemoveReportFavoriteMutationVariables>(RemoveReportFavoriteDocument, options);
      }
export type RemoveReportFavoriteMutationHookResult = ReturnType<typeof useRemoveReportFavoriteMutation>;
export type RemoveReportFavoriteMutationResult = Apollo.MutationResult<RemoveReportFavoriteMutation>;
export type RemoveReportFavoriteMutationOptions = Apollo.BaseMutationOptions<RemoveReportFavoriteMutation, RemoveReportFavoriteMutationVariables>;
export const SetChartOptionDocument = gql`
    mutation SetChartOption($id: ID!, $type: ChartOptionElement!, $input: ChartOptionInput!) {
  setChartOption(input: {id: $id, type: $type, input: $input}) {
    message
    success
    chartOption {
      ...ChartOptionFields
    }
  }
}
    ${ChartOptionFieldsFragmentDoc}`;
export type SetChartOptionMutationFn = Apollo.MutationFunction<SetChartOptionMutation, SetChartOptionMutationVariables>;

/**
 * __useSetChartOptionMutation__
 *
 * To run a mutation, you first call `useSetChartOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChartOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChartOptionMutation, { data, loading, error }] = useSetChartOptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetChartOptionMutation(baseOptions?: Apollo.MutationHookOptions<SetChartOptionMutation, SetChartOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetChartOptionMutation, SetChartOptionMutationVariables>(SetChartOptionDocument, options);
      }
export type SetChartOptionMutationHookResult = ReturnType<typeof useSetChartOptionMutation>;
export type SetChartOptionMutationResult = Apollo.MutationResult<SetChartOptionMutation>;
export type SetChartOptionMutationOptions = Apollo.BaseMutationOptions<SetChartOptionMutation, SetChartOptionMutationVariables>;
export const RemoveChartOptionDocument = gql`
    mutation RemoveChartOption($id: ID!, $type: ChartOptionElement!) {
  removeChartOption(input: {id: $id, type: $type}) {
    message
    success
  }
}
    `;
export type RemoveChartOptionMutationFn = Apollo.MutationFunction<RemoveChartOptionMutation, RemoveChartOptionMutationVariables>;

/**
 * __useRemoveChartOptionMutation__
 *
 * To run a mutation, you first call `useRemoveChartOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChartOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChartOptionMutation, { data, loading, error }] = useRemoveChartOptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRemoveChartOptionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveChartOptionMutation, RemoveChartOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveChartOptionMutation, RemoveChartOptionMutationVariables>(RemoveChartOptionDocument, options);
      }
export type RemoveChartOptionMutationHookResult = ReturnType<typeof useRemoveChartOptionMutation>;
export type RemoveChartOptionMutationResult = Apollo.MutationResult<RemoveChartOptionMutation>;
export type RemoveChartOptionMutationOptions = Apollo.BaseMutationOptions<RemoveChartOptionMutation, RemoveChartOptionMutationVariables>;
export const ResetChartOptionsDocument = gql`
    mutation ResetChartOptions($id: ID!) {
  resetChartOptions(input: {id: $id}) {
    message
    success
  }
}
    `;
export type ResetChartOptionsMutationFn = Apollo.MutationFunction<ResetChartOptionsMutation, ResetChartOptionsMutationVariables>;

/**
 * __useResetChartOptionsMutation__
 *
 * To run a mutation, you first call `useResetChartOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetChartOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetChartOptionsMutation, { data, loading, error }] = useResetChartOptionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetChartOptionsMutation(baseOptions?: Apollo.MutationHookOptions<ResetChartOptionsMutation, ResetChartOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetChartOptionsMutation, ResetChartOptionsMutationVariables>(ResetChartOptionsDocument, options);
      }
export type ResetChartOptionsMutationHookResult = ReturnType<typeof useResetChartOptionsMutation>;
export type ResetChartOptionsMutationResult = Apollo.MutationResult<ResetChartOptionsMutation>;
export type ResetChartOptionsMutationOptions = Apollo.BaseMutationOptions<ResetChartOptionsMutation, ResetChartOptionsMutationVariables>;
export const CreateChartUriDocument = gql`
    mutation CreateChartUri($input: ChartUriInput!) {
  createChartUri(input: {input: $input}) {
    success
    message
    chartUri {
      id
      base64
      title
    }
  }
}
    `;
export type CreateChartUriMutationFn = Apollo.MutationFunction<CreateChartUriMutation, CreateChartUriMutationVariables>;

/**
 * __useCreateChartUriMutation__
 *
 * To run a mutation, you first call `useCreateChartUriMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChartUriMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChartUriMutation, { data, loading, error }] = useCreateChartUriMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChartUriMutation(baseOptions?: Apollo.MutationHookOptions<CreateChartUriMutation, CreateChartUriMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChartUriMutation, CreateChartUriMutationVariables>(CreateChartUriDocument, options);
      }
export type CreateChartUriMutationHookResult = ReturnType<typeof useCreateChartUriMutation>;
export type CreateChartUriMutationResult = Apollo.MutationResult<CreateChartUriMutation>;
export type CreateChartUriMutationOptions = Apollo.BaseMutationOptions<CreateChartUriMutation, CreateChartUriMutationVariables>;
export const CreatePdfReportDocument = gql`
    mutation CreatePdfReport($input: PdfReportInput!) {
  createPdfReport(input: {input: $input}) {
    success
    message
    pdfReport {
      id
      randomKey
      status
      percentComplete
    }
  }
}
    `;
export type CreatePdfReportMutationFn = Apollo.MutationFunction<CreatePdfReportMutation, CreatePdfReportMutationVariables>;

/**
 * __useCreatePdfReportMutation__
 *
 * To run a mutation, you first call `useCreatePdfReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePdfReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPdfReportMutation, { data, loading, error }] = useCreatePdfReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePdfReportMutation(baseOptions?: Apollo.MutationHookOptions<CreatePdfReportMutation, CreatePdfReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePdfReportMutation, CreatePdfReportMutationVariables>(CreatePdfReportDocument, options);
      }
export type CreatePdfReportMutationHookResult = ReturnType<typeof useCreatePdfReportMutation>;
export type CreatePdfReportMutationResult = Apollo.MutationResult<CreatePdfReportMutation>;
export type CreatePdfReportMutationOptions = Apollo.BaseMutationOptions<CreatePdfReportMutation, CreatePdfReportMutationVariables>;